/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var thenable = require('../../utils/promise/thenable');

var EventsCache = function () {
  function EventsCache(context) {
    var _this = this;

    (0, _classCallCheck3.default)(this, EventsCache);

    var settings = context.get(context.constants.SETTINGS);
    var eventsModule = context.get(context.constants.EVENTS);

    this.onFullQueue = false;
    this.maxQueue = settings.scheduler.eventsQueueSize;
    this.queue = [];

    if (thenable(eventsModule)) {
      eventsModule.then(function (events) {
        _this.onFullQueue = events.flushAndResetTimer;
        _this._checkQueueSize(); // Events is ready, check the queue.
      });
    } else if (typeof eventsModule.flushAndResetTimer === 'function') {
      this.onFullQueue = eventsModule.flushAndResetTimer;
    }
  }

  /**
   * Get the current state of the queue.
   */


  (0, _createClass3.default)(EventsCache, [{
    key: 'state',
    value: function state() {
      return this.queue;
    }

    /**
     * Add a new event object at the end of the queue.
     */

  }, {
    key: 'track',
    value: function track(data) {
      this.queue.push(data);

      this._checkQueueSize();

      return this;
    }

    /**
     * Clear the data stored on the cache.
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.queue = [];

      return this;
    }

    /**
     * Returns the payload we will use for posting data.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      return this.queue;
    }

    /**
     * Check if the cache is empty.
     */

  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.queue.length === 0;
    }

    /**
     * Check if the cache queue is full and we need to flush it.
     */

  }, {
    key: '_checkQueueSize',
    value: function _checkQueueSize() {
      // 0 means no maximum value, in case we want to avoid this being triggered.
      if (this.maxQueue > 0 && this.queue.length >= this.maxQueue) {
        this.onFullQueue && this.onFullQueue();
      }
    }
  }]);
  return EventsCache;
}();

module.exports = EventsCache;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/storage/EventsCache/InMemory.js
// module id = 681
// module chunks = 7